import { MenuItem, Text } from "@chakra-ui/react"
import { useRouter } from "next/router"
import PropTypes from "prop-types"
import { getArchivedArticlePdfData, getArticlePdfData } from "../../../../../../../src/common/hooks/queries"
import { fileTypes } from "../../../../../../common/constants/constants"
import { useBrandedTranslation } from "../../../../../../common/hooks/useBrandedTranslation"
import { useDownloadFile } from "../../../../../../common/hooks/useDownloadFile"
import LoadingIcon from "../../../../../shared/DownloadButton/LoadingIcon"
import { CPdfArticleTable } from "../../../../../shared/Icons"

const DownloadArticlePDFMenuItem = ({ articleCode, isArchived }) => {
  const { t } = useBrandedTranslation()
  const { locale, query } = useRouter()
  const brand = String(query.brand)
  const getPDFData = isArchived ? getArchivedArticlePdfData : getArticlePdfData

  /* Hook for download of the PDF button */
  const { onClickDownloadFile: onClickDownloadArticlePdf, isFileLoading: isArticlePdfFileDownloading } =
    useDownloadFile(articleCode, brand, locale, fileTypes.PDF, getPDFData, null, articleCode)
  if (!articleCode) return null

  return (
    <MenuItem
      icon={isArticlePdfFileDownloading ? <LoadingIcon /> : <CPdfArticleTable />}
      isDisabled={isArticlePdfFileDownloading}
      onClick={onClickDownloadArticlePdf}
      aria-label="Download a PDF with data for current article"
    >
      <Text fontWeight="medium">{t("pdp-downloadArticlePDF")}</Text>
    </MenuItem>
  )
}

export default DownloadArticlePDFMenuItem

DownloadArticlePDFMenuItem.propTypes = {
  articleCode: PropTypes.string,
  isArchived: PropTypes.bool,
}
